import React from 'react';

const OptimizedImage = ({ 
  src, 
  alt, 
  className = '', 
  priority = false,
  width,
  height,
  ...props 
}) => {
  // Optimize Unsplash URLs for better performance
  const optimizeImageUrl = (url) => {
    if (url.includes('unsplash.com')) {
      // Add width parameter for automatic optimization
      const separator = url.includes('?') ? '&' : '?';
      return `${url}${separator}w=1200&auto=format&fit=crop&q=80`;
    }
    return url;
  };

  return (
    <img
      src={optimizeImageUrl(src)}
      alt={alt}
      className={className}
      loading={priority ? 'eager' : 'lazy'}
      decoding="async"
      width={width}
      height={height}
      {...props}
    />
  );
};

export default OptimizedImage;

